var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarCart = function SvgCarCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 11.25C23.2497 10.2895 22.8681 9.36832 22.189 8.689L20.25 6.75H3.75L1.811 8.689C1.13191 9.36832 0.750294 10.2895 0.75 11.25C0.75 11.6478 0.908035 12.0294 1.18934 12.3107C1.47064 12.592 1.85218 12.75 2.25 12.75H8.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07495 9.75H5.24995",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9251 9.75H21.0371",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7776 12L14.5986 19.756C14.651 19.8999 14.7461 20.0243 14.8712 20.1126C14.9964 20.2009 15.1455 20.2488 15.2986 20.25H20.6706C20.8175 20.2498 20.9611 20.2067 21.0837 20.1258C21.2063 20.0449 21.3026 19.9299 21.3606 19.795L22.9676 15.3C23.0167 15.1859 23.0366 15.0614 23.0256 14.9377C23.0146 14.814 22.9731 14.6949 22.9046 14.5913C22.8362 14.4876 22.743 14.4026 22.6336 14.3439C22.5241 14.2852 22.4018 14.2547 22.2776 14.255H12.5966",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6526 23.25C19.8597 23.25 20.0276 23.0821 20.0276 22.875C20.0276 22.6679 19.8597 22.5 19.6526 22.5",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6526 23.25C19.4455 23.25 19.2776 23.0821 19.2776 22.875C19.2776 22.6679 19.4455 22.5 19.6526 22.5",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9026 23.25C16.1097 23.25 16.2776 23.0821 16.2776 22.875C16.2776 22.6679 16.1097 22.5 15.9026 22.5",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9026 23.25C15.6955 23.25 15.5276 23.0821 15.5276 22.875C15.5276 22.6679 15.6955 22.5 15.9026 22.5",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75L5.45 2.21C5.61083 1.7807 5.89902 1.4108 6.27595 1.14986C6.65288 0.888918 7.10056 0.749402 7.559 0.750002H16.441C16.8989 0.750014 17.3459 0.889814 17.7223 1.15071C18.0986 1.41161 18.3863 1.78118 18.547 2.21L20.247 6.75H3.75Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75C4.14782 15.75 4.52936 15.592 4.81066 15.3107C5.09196 15.0294 5.25 14.6478 5.25 14.25V12.75H2.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCarCart;